export default __webpack_public_path__ + "static/media/AntyLucy_6.a874491a.jpg";